import Grid from "@mui/material/Grid";
import {FormControlLabel, FormHelperText, InputLabel, Switch, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import {Add} from "@mui/icons-material";
import * as React from "react";

export default function CurrencyForm ({fields, errors, handleChange, handleBlur, handleSubmit}) {
    return <React.Fragment>
        <Grid container spacing={2}
              component="form"
              onSubmit={handleSubmit}
              autoComplete="off"
        >
            <Grid size={{ xs: 12, md: 4 }}>
                <InputLabel>Currency Code</InputLabel>
                <TextField
                    error={!!errors.currency}
                    value={fields.currency || ""}
                    name="currency"
                    id="currency"
                    required={true}
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                {errors.currency && <FormHelperText>{errors.currency}</FormHelperText>}
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <InputLabel>Subunit</InputLabel>
                <TextField
                    error={!!errors.subunit}
                    value={fields.subunit || ""}
                    name="subunit"
                    type="number"
                    id="subunit"
                    required={true}
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                {errors.subunit && <FormHelperText>{errors.subunit}</FormHelperText>}
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <InputLabel>Symbol</InputLabel>
                <TextField
                    error={!!errors.symbol}
                    value={fields.symbol || ""}
                    name="symbol"
                    type="text"
                    id="symbol"
                    required={true}
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                {errors.symbol && <FormHelperText>{errors.symbol}</FormHelperText>}
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <FormControlLabel
                    control={
                        <Switch
                            name="enabled"
                            checked={fields.enabled !== false}
                            onChange={(ev) => handleChange({ target: { name: 'enabled', value: ev.target.checked } })}
                        />
                    }
                    label="Available for payments"
                />
            </Grid>
            <Grid container size={12} spacing={3} sx={{mt: 2}}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Button type="submit" onClick={handleSubmit} variant="outlined" startIcon={<Add />} >
                        Submit
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    </React.Fragment>
}
